import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

/**
 * Sends the window back to the top whenever the route changes, so links (for example in the
 * footer) open the next page at its start rather than keeping the previous scroll position.
 * Navigations that only add a hash are left alone so in-page anchors still work, and going
 * back or forward keeps the position the browser restores.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (hash || history.action === "POP") return;
    window.scrollTo(0, 0);
  }, [pathname, hash, history.action]);

  return null;
}
